import React from 'react';
import { RouteObject } from 'react-router-dom';
import { societesBasePath, listeSocietesPath } from './constants';
import { SocietesRoot } from './societesRoot';
import ListeSousClient from './page/liste/ListeSousClient';
import ListeSousClientPrescripteurWrapper from './page/liste/ListeSousClientPrescripteurWrapper';

export const SocietesRouter: RouteObject = {
    path: societesBasePath,
    element: <SocietesRoot />,
    children: [
        {
            path: listeSocietesPath,
            element: <ListeSousClientPrescripteurWrapper showPrescripteur={false} />,
        },
    ],
};

export const SocietesRouterBack: RouteObject = {
    path: societesBasePath,
    element: <SocietesRoot />,
    children: [
        {
            path: listeSocietesPath,
            element: <ListeSousClient showPrescripteur />,
        },
    ],
};
